import { Icon } from "../common/icons"
import { Box, Flex } from "@chakra-ui/layout"
import { FaExclamationCircle } from "react-icons/fa"

const DeniedPermissionWarning = ({
  children,
  isDenied,
  top = null,
  right = null
}) => {
  return (
    <Flex position="relative">
      {children}
      {isDenied && (
        <Box
          borderRadius="50%"
          position="absolute"
          top={top ?? "-18px"}
          right={right ?? "-8px"}
        >
          <Icon
            src={FaExclamationCircle}
            color="red"
            background="white"
            width={"14px"}
            height={"14px"}
            borderWidth="0"
            borderRadius="50%"
          />
        </Box>
      )}
    </Flex>
  )
}

export default DeniedPermissionWarning
